import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Separator } from '../../../../../../CommonComponents/OPL/Separator/Separator';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { DraggableItem } from '../../../AssetBucketingResults/components/Bucket/components/DraggableItem/DraggableItem';
import { AssetDTO } from '../../api/useAssetBucketingDetailsQuery';

interface Props {
  assets: AssetDTO[];
}

export const UnassignedAssets = ({ assets }: Props) => {
  if (assets.length === 0) {
    return null;
  }

  return (
    <Box mt={64} mb="8">
      <Text as="h2" fontWeight={600} color="neutral.600" fontSize="h4" mb="8">
        Unassigned Assets
      </Text>

      <Separator />

      <Box
        display="grid"
        as="ul"
        mt="24"
        p={0}
        css={`
          list-style: none;
          grid-template-columns: repeat(3, 1fr);
          gap: ${({ theme }) => theme.space[8]}px;
        `}
      >
        {assets.map(asset => (
          <DraggableItem
            key={asset.id}
            bucketIndex={-1}
            id={asset.id}
            name={asset.title}
            y={asset.value}
            holdings={[]}
            transactions={[]}
            isUnassigned
            displayValue={asset.value}
            networthValue={asset.value}
          />
        ))}
      </Box>
    </Box>
  );
};
